export type Rahmen = { x: number; y: number; w: number; h: number };

export const normalisiere = (x1: number, y1: number, x2: number, y2: number): Rahmen => ({
  x: Math.min(x1, x2), y: Math.min(y1, y2), w: Math.abs(x2 - x1), h: Math.abs(y2 - y1),
});

/** CSS-Pixel → Bildpixel; auf die Bildfläche begrenzt. */
export function inBildpixel(r: Rahmen, faktor: number, bildBreite: number, bildHoehe: number): Rahmen {
  const x1 = Math.max(0, Math.round(r.x * faktor));
  const y1 = Math.max(0, Math.round(r.y * faktor));
  const x2 = Math.min(bildBreite, Math.round((r.x + r.w) * faktor));
  const y2 = Math.min(bildHoehe, Math.round((r.y + r.h) * faktor));
  return { x: x1, y: y1, w: Math.max(0, x2 - x1), h: Math.max(0, y2 - y1) };
}
